export default {
    id: 'blue-gray-red',
    colors: ['#0044A3', '#D8D8D8', '#BA2534'],
};
